/* ============ Product detail page ============ */
gsap.registerPlugin(ScrollTrigger);
(function pdp(){
  const $=s=>document.querySelector(s);
  if(!$('#pdMain')||!window.OSO_PRODUCTS) return;
  if(window.osoAmbient) osoAmbient();
  const q=new URLSearchParams(location.search);
  const p=OSO_findProduct(q.get('id'));
  const fromUrl=q.get('c')?('#'+q.get('c').replace('#','')):null;
  let cur=(fromUrl&&OSO_COLORS.some(c=>c[0]===fromUrl))?fromUrl:p.color;
  let curCn=OSO_colorName(cur), shot=0;
  const selSize=()=>{const z=document.querySelector('#pdSizes .pd-z.on');return z?z.textContent.trim():'';};
  const qty=()=>{const n=$('#pdQty');return n?Math.max(1,+n.textContent||1):1;};
  const rup=n=>'₹'+n.toLocaleString('en-IN');

  document.title=p.name+' · OSO';
  $('#pdCrumb').textContent=p.name; $('#pdName').textContent=p.name; $('#pdBlurb').textContent=p.blurb;
  $('#pdPrice').textContent=rup(p.price); $('#pdDesc').textContent=p.desc; $('#pdCn').textContent=curCn;
  $('#pdStickyName').textContent=p.name; $('#pdStickyPrice').textContent=rup(p.price);
  const bd=$('#pdBadge'); if(bd) bd.style.display='none';   // marketing tags removed from the range

  /* a colourway with nothing left in any size is still shown, but struck out */
  function paintSwatches(){
    $('#pdSw').innerHTML=OSO_productColors(p).map(c=>{
      const out=!OSO_colorInStock(p.id,c[2]);
      return `<button class="pd-s${c[0]===cur?' on':''}${out?' oos':''}" style="--c:${c[0]}" data-c="${c[0]}" data-n="${c[1]}"`+
             ` aria-label="${c[1]}${out?', sold out':''}"${out?' disabled':''}></button>`;
    }).join('');
  }
  /* Sizes are per colourway, not global — the Bear Tee in Night was only cut in
     M and XL. Keeps the chosen size if this colour still has it, otherwise falls
     back to the first size that is actually on the shelf. */
  function paintSizes(){
    const ck=OSO_colorKey(cur), want=selSize();
    const rows=OSO_sizesFor(p.id,ck);
    const keep=rows.some(r=>r[0]===want&&r[1]>0)?want:OSO_defaultSize(p.id,ck);
    $('#pdSizes').innerHTML=rows.map(([s,n])=>
      `<button class="pd-z${s===keep?' on':''}${n?'':' oos'}"${n?'':' disabled'} `+
      `aria-label="${s}${n?'':', sold out'}">${s}</button>`).join('');
    const add=$('#pdAdd'), none=!keep;
    if(add){ add.disabled=none; add.classList.toggle('sold',none);
      const lbl=add.querySelector('span'); if(lbl) lbl.textContent=none?'Sold out':'Add to bag'; }
    const sticky=$('#pdStickyAdd');
    if(sticky){ sticky.disabled=none; sticky.textContent=none?'Sold out':'Add to bag'; }
  }
  paintSwatches();
  paintSizes();

  /* ---- gallery: the real photographs for this colourway ---- */
  function paintGallery(animate){
    const g=OSO_gallery(p,OSO_colorKey(cur));
    shot=Math.min(shot,Math.max(0,g.length-1));
    $('#pdMain').innerHTML=shopTeeBig(cur,p,shot);
    $('#pdThumbs').hidden=!g.length;
    $('#pdThumbs').innerHTML=g.map((t,i)=>
      `<button class="pdp-thumb${i===shot?' on':''}" data-i="${i}" aria-label="${t[1]}">${shopTee(cur,p,{i})}<span class="lbl">${t[1]}</span></button>`).join('');
    if(animate) gsap.fromTo('#pdMain .tee-img',{scale:1.05,autoAlpha:.25},{scale:1,autoAlpha:1,duration:.45,ease:'power2.out'});
    syncArrows();   // colourways carry different numbers of shots
  }
  paintGallery(false);

  /* ---- related: the other design, plus this one in other colours ---- */
  $('#pdRelated').innerHTML=OSO_VARIANTS()
    .filter(v=>!(v.p.id===p.id&&v.hex===cur)).slice(0,8)
    .map(v=>`<a class="pdp-rcard" href="/pages/product?id=${v.p.id}&c=${v.hex.slice(1)}"><div class="im">${shopTee(v.hex,v.p.print)}</div><div class="cb"><div class="cn">${v.p.name}</div><div class="cp">${v.cn} · ${rup(v.p.price)}</div></div></a>`).join('');

  if(window.osoPeek){ osoPeek('.pdp-gallery',{width:84,slots:[10,50,86]}); osoPeek('#pdRelated',{width:88}); }

  // ---- interactions ----
  function setColor(c,n){
    cur=c;curCn=n;shot=0;
    document.querySelectorAll('#pdSw .pd-s').forEach(x=>x.classList.toggle('on',x.dataset.c===c));
    $('#pdCn').textContent=n;
    paintGallery(true);
    paintSizes();          // this colourway may not be cut in every size
    syncFav();
    history.replaceState(null,'',`/pages/product?id=${p.id}&c=${c.slice(1)}`);
  }
  $('#pdSw').addEventListener('click',e=>{const s=e.target.closest('.pd-s'); if(s) setColor(s.dataset.c,s.dataset.n);});
  $('#pdSizes').addEventListener('click',e=>{const z=e.target.closest('.pd-z'); if(!z||z.disabled||z.classList.contains('oos')||z.classList.contains('soon')) return;
    document.querySelectorAll('#pdSizes .pd-z').forEach(x=>x.classList.toggle('on',x===z));});
  /* one place to move the gallery on, whether a thumbnail, an arrow or a swipe asked */
  function showShot(i,dir){
    const g=OSO_gallery(p,OSO_colorKey(cur));
    if(!g.length) return;
    shot=(i+g.length)%g.length;                 // wraps, so the arrows never dead-end
    document.querySelectorAll('.pdp-thumb').forEach(x=>x.classList.toggle('on',+x.dataset.i===shot));
    $('#pdMain').innerHTML=shopTeeBig(cur,p,shot);
    const from=dir?{x:dir*40,autoAlpha:.3}:{scale:1.04,autoAlpha:.3};
    gsap.fromTo('#pdMain .tee-img',from,{x:0,scale:1,autoAlpha:1,duration:.4,ease:'power2.out'});
    syncArrows();
  }
  /* a single photograph needs no arrows */
  function syncArrows(){
    const n=OSO_gallery(p,OSO_colorKey(cur)).length, hide=n<2;
    ['#pdPrev','#pdNext'].forEach(sel=>{const b=$(sel); if(b) b.hidden=hide;});
  }
  $('#pdThumbs').addEventListener('click',e=>{const t=e.target.closest('.pdp-thumb'); if(!t) return;
    showShot(+t.dataset.i,0);});
  if($('#pdPrev')) $('#pdPrev').addEventListener('click',()=>showShot(shot-1,-1));
  if($('#pdNext')) $('#pdNext').addEventListener('click',()=>showShot(shot+1,1));
  syncArrows();

  /* quantity stepper */
  const qw=$('#pdQtyWrap');
  if(qw) qw.addEventListener('click',e=>{const b=e.target.closest('[data-q]'); if(!b) return;
    const el=$('#pdQty'); el.textContent=Math.max(1,Math.min(9,(+el.textContent||1)+ +b.dataset.q));
    gsap.fromTo(el,{scale:.7},{scale:1,duration:.3,ease:'back.out(3)'});});

  const addFx=(btn,label)=>{if(btn.classList.contains('done'))return;const t=btn.innerHTML;btn.classList.add('done');btn.textContent=label;
    gsap.fromTo(btn,{scale:.96},{scale:1,duration:.35,ease:'back.out(2)'});setTimeout(()=>{btn.classList.remove('done');btn.innerHTML=t;},1700);};
  const addBag=(btn,label)=>{if(window.OSO_STORE)OSO_STORE.addToCart(p.id,cur,curCn,selSize(),qty());addFx(btn,label);};
  $('#pdAdd').addEventListener('click',()=>addBag($('#pdAdd'),'Added to bag ✓'));
  $('#pdStickyAdd').addEventListener('click',()=>addBag($('#pdStickyAdd'),'Added ✓'));

  /* The sticky bar is fixed to the bottom, so while the real Add to bag button is on
     screen the bar is redundant and just covers the gallery.

     "Not intersecting" is not enough on its own: on a phone the layout is one column
     with the gallery first, so at the top of the page the real button is not
     intersecting either — it is still BELOW the fold. Showing the bar then is exactly
     the overlap this is meant to avoid. Only show it once the button is above the
     viewport, i.e. genuinely scrolled past. */
  (function stickyBar(){
    const bar=document.querySelector('.pdp-sticky');
    if(!bar) return;
    /* Appear after a short scroll and nothing more. It must not be up on landing —
       that was the bug, it sat on the gallery. Tying it to the thumbnails clearing,
       or to the Add to bag button scrolling past, both put it several screens down,
       which is useless. Past this point the gallery has moved up and the page carries
       bottom padding so the footer stays clear. */
    const update=()=>{
      const y = window.scrollY || document.documentElement.scrollTop || 0;
      bar.classList.toggle('on', y > 220);
    };
    update();
    addEventListener('scroll', update, {passive:true});
    addEventListener('resize', update);
  })();

  const fav=$('#pdFav');
  const syncFav=()=>fav.classList.toggle('on',!!window.OSO_STORE&&OSO_STORE.inWishlist(p.id,cur));
  syncFav();
  fav.addEventListener('click',()=>{if(window.OSO_STORE)OSO_STORE.toggleWishlist(p.id,cur);
    syncFav();gsap.fromTo(fav,{scale:.7},{scale:1,duration:.4,ease:'back.out(3)'});});
  window.addEventListener('oso:store',syncFav);

  $('#pdSizeGuide').addEventListener('click',()=>{const sc=document.getElementById('pdSizeChart');if(sc)sc.scrollIntoView({behavior:'smooth',block:'start'});});

  /* the main frame zooms toward the cursor instead of tilting a flat svg */
  const main=$('.pdp-main');
  if(!matchMedia('(pointer:coarse)').matches){
    main.addEventListener('mousemove',e=>{const r=main.getBoundingClientRect();
      gsap.to('#pdMain .tee-img',{scale:1.14,transformOrigin:`${((e.clientX-r.left)/r.width*100).toFixed(1)}% ${((e.clientY-r.top)/r.height*100).toFixed(1)}%`,duration:.5,ease:'power2',overwrite:'auto'});});
    main.addEventListener('mouseleave',()=>gsap.to('#pdMain .tee-img',{scale:1,duration:.6,ease:'power2',overwrite:'auto'}));
  }
  // entrance choreography
  gsap.from('.pdp-main',{x:-26,autoAlpha:0,scale:.97,duration:.9,ease:'power3.out',delay:.1});
  gsap.from('.pdp-info > *',{y:22,autoAlpha:0,duration:.65,stagger:.06,ease:'power2.out',delay:.25});
  gsap.from('.pdp-thumb',{y:16,autoAlpha:0,duration:.55,stagger:.08,ease:'power2.out',delay:.65});
  // reveal the lower sections
  ['.pdp-sizechart','.pdp-related','.pdp-cert','.pdp-life'].forEach(sel=>gsap.from(sel,{y:38,autoAlpha:0,duration:.75,ease:'power2.out',scrollTrigger:{trigger:sel,start:'top 86%',once:true}}));
})();
